import { render } from "./accessoireListe.vue?vue&type=template&id=4e2289f2&scoped=true"
import script from "./accessoireListe.vue?vue&type=script&lang=js"
export * from "./accessoireListe.vue?vue&type=script&lang=js"

import "./accessoireListe.vue?vue&type=style&index=0&id=4e2289f2&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2289f2"]])

export default __exports__